// extracted by mini-css-extract-plugin
export default {"banner":"nWQNstueEBSBEhLg5Z91","content":"GQm9_FAB6_zflJaq39vf","message":"oY5WbYmTsXu4FGENKcT2","spacer":"KldSE8skmNw5UjoFP6Bz","closeButton":"WGKzHdY2cAIltOzOL4jm"};